"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvalidLotExpiryCaseSubType = exports.InvalidLotExpiryCaseStatus = void 0;
var InvalidLotExpiryCaseStatus;
(function (InvalidLotExpiryCaseStatus) {
    InvalidLotExpiryCaseStatus["PENDING"] = "PENDING";
    InvalidLotExpiryCaseStatus["RESOLVED"] = "RESOLVED";
    InvalidLotExpiryCaseStatus["COMPLETED"] = "COMPLETED";
    InvalidLotExpiryCaseStatus["CANCELLED"] = "CANCELLED";
})(InvalidLotExpiryCaseStatus = exports.InvalidLotExpiryCaseStatus || (exports.InvalidLotExpiryCaseStatus = {}));
var InvalidLotExpiryCaseSubType;
(function (InvalidLotExpiryCaseSubType) {
    InvalidLotExpiryCaseSubType["UNDECLARED"] = "UNDECLARED";
    InvalidLotExpiryCaseSubType["UNEXPECTED"] = "UNEXPECTED";
    InvalidLotExpiryCaseSubType["ILLEGIBLE"] = "ILLEGIBLE";
    InvalidLotExpiryCaseSubType["MISDIRECTED"] = "MISDIRECTED";
    InvalidLotExpiryCaseSubType["IN_TRANSIT_LOT_EXP_UPDATE"] = "IN_TRANSIT_LOT_EXP_UPDATE";
    InvalidLotExpiryCaseSubType["VALID"] = "VALID";
})(InvalidLotExpiryCaseSubType = exports.InvalidLotExpiryCaseSubType || (exports.InvalidLotExpiryCaseSubType = {}));
//# sourceMappingURL=InvalidLotExpiryCase.js.map